"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_strict_prop_1 = __importDefault(require("vue-strict-prop"));
const tsx = __importStar(require("vue-tsx-support"));
const api = __importStar(require("@codegrade/api"));
const icons = __importStar(require("@codegrade/icons"));
const utils_1 = require("@codegrade/utils");
const Icon_1 = require("@/components/Icon");
const User_1 = __importDefault(require("@/components/User"));
const store_1 = require("@/store");
const utils = __importStar(require("@/utils"));
const AbbreviatedTime_1 = __importDefault(require("../AbbreviatedTime"));
exports.default = tsx.componentFactoryOf().create({
    name: 'user-notification',
    props: {
        notification: vue_strict_prop_1.default.ofType().required,
        checked: (0, vue_strict_prop_1.default)(Boolean).default(false),
    },
    computed: {
        assignment() {
            store_1.AssignmentsStore.loadSingleAssignment({ assignmentId: this.notification.assignmentId });
            return store_1.AssignmentsStore.getAssignment()(this.notification.assignmentId, {});
        },
        submission() {
            return store_1.SubmissionsStore.getSingleSubmission()(this.notification.workId);
        },
        feedbackType() {
            return utils_1.expr.match(this.notification, 'type', {
                general_comment_notification: () => 'a general',
                comment_notification: () => 'an inline',
            });
        },
        notificationRoute() {
            const notification = this.notification;
            const baseRoute = {
                params: {
                    courseId: notification.courseId.toString(10),
                    assignmentId: notification.assignmentId.toString(10),
                    submissionId: notification.workId.toString(10),
                },
                query: {
                    replyToFocus: `${notification.commentBaseId}-${notification.commentReply.id}`,
                },
            };
            return utils_1.expr.match(notification, 'type', {
                general_comment_notification: () => ({
                    ...baseRoute,
                    name: 'submission',
                    hash: '#feedback-overview',
                }),
                comment_notification: ({ fileId }) => ({
                    ...baseRoute,
                    name: 'submission_file',
                    params: {
                        ...baseRoute.params,
                        fileId: fileId.toString(),
                    },
                    hash: '#code',
                }),
            });
        },
        readStatusNode() {
            return utils.ifExpr(this.notification.read, () => <td class="w-6 text-center align-middle !px-0"/>, () => (<td class="min-w-6 w-6 text-center align-middle !px-0">
                        <Icon_1.Icon icon={icons.CircleDot} filled={true} scale={0.5} class="text-positive-40"/>
                    </td>));
        },
        checkboxNode() {
            const notificationId = `notification-checkbox-${this.notification.id}`;
            const assignmentName = this.assignment.map(a => a.name).orDefault('unknown assignment');
            return (<td class="w-4 !pl-1 align-middle" aria-label={`Select ${this.feedbackType} feedback notification for ${assignmentName}`}>
                    <input id={notificationId} type="checkbox" class="size-4 align-middle" disabled={this.notification.read} checked={this.checked} aria-label={`Select notification about ${this.feedbackType} feedback`} onInput={(event) => {
                    const target = event.target;
                    tsx.emitOn(this, 'onToggleCheckbox', {
                        notificationId: this.notification.id,
                        checked: target.checked,
                    });
                }}/>
                </td>);
        },
        contentNode() {
            const url = this.$router.resolve(this.notificationRoute).href;
            return (<td class="flex">
                    <a href={url} onClick={(e) => {
                    e.preventDefault();
                    this.handleRowClick(e);
                }} onKeydown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        this.handleRowClick(e);
                    }
                }}>
                        Submission by {this.userNode} for {this.assignmentNameNode}
                    </a>
                </td>);
        },
        userNode() {
            return utils_1.maybe.and(this.assignment, this.submission).caseOf({
                Nothing: () => <span class="italic">unknown</span>,
                Just: ([assignment, submission]) => (<User_1.default user={submission.user} anonymize-for={assignment} showWhenYou="you"/>),
            });
        },
        assignmentNameNode() {
            return this.assignment.caseOf({
                Nothing: () => utils.ELLIPSIS,
                Just: assignment => <div class="contents">"{assignment.name}"</div>,
            });
        },
        authorNode() {
            const reply = this.notification.commentReply;
            if (reply instanceof api.ExtendedNonDeletedCommentReply) {
                return (<template>
                        {reply.author.caseOf({
                        Nothing: () => 'Someone',
                        Just: author => (<User_1.default user={author} anonymize-for={this.assignment.unsafeCoerce()}/>),
                    })}
                        commented on {this.feedbackType} feedback thread you are following.
                    </template>);
            }
            if (reply instanceof api.DeletedCommentReply) {
                return `A comment was deleted on ${this.feedbackType} feedback thread you are following.`;
            }
            throw utils_1.assert.AssertionError.assertNever(reply);
        },
        badgesNode() {
            return (<td class="badge-wrapper shrink gap-2">
                    {this.notification.reasons.map(([reason, explanation]) => (<b-badge key={reason} class="px-2 py-1 mr-1" title={utils_1.string.capitalize(explanation)}>
                            {reason}
                        </b-badge>))}
                </td>);
        },
        timeNode() {
            return (<td class="shrink text-sm text-right align-middle !pr-5">
                    <AbbreviatedTime_1.default date={this.notification.createdAt} class="time-display"/>
                </td>);
        },
    },
    methods: {
        async handleRowClick(event) {
            const location = this.notificationRoute;
            utils.loadBackgroundPromises(store_1.NotificationStore.markAsRead({ notification: this.notification }));
            this.$root.$emit('cg::sidebar::close');
            if (event != null && (event.ctrlKey || event.metaKey)) {
                if (this.checked) {
                    tsx.emitOn(this, 'onToggleCheckbox', {
                        notificationId: this.notification.id,
                        checked: false,
                    });
                }
                const url = this.$router.resolve(location).href;
                window.open(url, '_blank');
            }
            else {
                await this.$router.push(location);
            }
        },
    },
    render() {
        const ariaLabel = `Notification: ${this.feedbackType} feedback on ${this.assignment
            .map(a => a.name)
            .orDefault('assignment')} - ${this.notification.read ? 'read' : 'unread'}`;
        return (<tr class={{
                'user-notification': true,
                read: this.notification.read,
                'cursor-default': true,
            }} aria-label={ariaLabel}>
                {this.readStatusNode}
                {this.checkboxNode}
                {this.contentNode}
                {this.badgesNode}
                {this.timeNode}
            </tr>);
    },
});
